export const CErrorAuthContext = {
    LOGIN:'LOGIN',
    REGISTER:'REGISTER',
    VERIFY:'VERIFY',
    INVITATION:'INVITATION',
    SIGN_UP: 'SIGN_UP',
} as const;